import CustomizeReportLayout from "./CustomizeReportLayout";

export default CustomizeReportLayout;
